import React from 'react';
import { Dialog } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import {
  DialogZoomTransition,
  DIALOG_ZOOM_MS,
  dialogZoomSlotProps,
  dialogZoomDialogSx,
  dialogZoomPaperSx,
} from '../DialogZoomTransition';
import {
  ImageModalOverlay,
  ImageModalContainer,
  ImageModalHeader,
  ImageModalCloseButton,
  ImageModalContent,
  ExpandedImage,
} from './ImageModal.styles';

export interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  altText?: string;
}

const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  onClose,
  imageUrl,
  altText = 'Imagen del producto',
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={false}
      TransitionComponent={DialogZoomTransition}
      transitionDuration={DIALOG_ZOOM_MS}
      slotProps={dialogZoomSlotProps}
      PaperProps={{
        sx: dialogZoomPaperSx({
          maxWidth: '90vw',
          maxHeight: '90vh',
          width: 'auto',
          height: 'auto',
          backgroundColor: 'transparent',
          boxShadow: 'none',
          margin: 'auto',
          alignSelf: 'center',
          position: 'relative',
          justifyContent: 'center',
          alignItems: 'center',
        }),
      }}
      sx={dialogZoomDialogSx}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      }}
    >
      <ImageModalOverlay>
        <ImageModalContainer>
          <ImageModalHeader>
            <ImageModalCloseButton onClick={onClose}>
              <CloseIcon />
            </ImageModalCloseButton>
          </ImageModalHeader>
          <ImageModalContent>
            <ExpandedImage src={imageUrl} alt={altText} onClick={(e) => e.stopPropagation()} />
          </ImageModalContent>
        </ImageModalContainer>
      </ImageModalOverlay>
    </Dialog>
  );
};

export default ImageModal;
